import React, { useState, useEffect } from 'react';
import AnalyticsStatCard from '../../components/AnalyticsStatCard';
import { CalendarBlank, CheckCircle, Clock, Percent, UserGear } from '@phosphor-icons/react';
import COLORS from '../../util/constants/colors';
import { calculateReportTime } from './helpers';

const ReferralStats = ({ analyticsData, loading }) => {
  const [averageScheduledTime, setAverageScheduledTime] = useState(0);
  const [averageTimeToFirstStatusChange, setAverageTimeToFirstStatusChange] = useState(0);

  useEffect(() => {
    setAverageScheduledTime(calculateReportTime(analyticsData.average_scheduled_time));
    setAverageTimeToFirstStatusChange(calculateReportTime(analyticsData.average_time_to_first_status_change));
  }, [analyticsData]);

  return (
    <div className="analytics-stats">
      <AnalyticsStatCard
        label="Unique Referrals Received"
        value={analyticsData.unique_referrals}
        valueColor={COLORS.SUCCESS_HOVER_LITE}
        icon={<UserGear size={24} weight="bold" />}
        iconColor={COLORS.SUCCESS_SECONDARY_DARK}
        loading={loading}
      />
      <AnalyticsStatCard
        label="% of Referrals Scheduled"
        value={analyticsData.percentage_referrals_scheduled}
        valueColor={COLORS.BLUE_PRIMARY_LITE}
        unit="%"
        icon={<Percent size={24} weight="bold" />}
        iconColor={COLORS.BLUE}
        loading={loading}
      />
      <AnalyticsStatCard
        label="% of Referrals Completed"
        value={analyticsData.percentage_referrals_completed}
        valueColor={COLORS.SUCCESS_HOVER_LITE}
        unit="%"
        icon={<CheckCircle size={24} weight="bold" />}
        iconColor={COLORS.SUCCESS_SECONDARY_DARK}
        loading={loading}
      />
      <AnalyticsStatCard
        label="Avg Time to Schedule"
        value={averageScheduledTime}
        valueColor={COLORS.ORANGE_PRIMARY_LITE}
        icon={<CalendarBlank size={24} weight="bold" />}
        iconColor={COLORS.ATTENTION_SECONDARY_LITE}
        loading={loading}
      />
      <AnalyticsStatCard
        label="Avg Time to First Contact"
        value={averageTimeToFirstStatusChange}
        valueColor={COLORS.PURPLE_PRIMARY_LITE}
        icon={<Clock size={24} weight="bold" />}
        iconColor={COLORS.PURPLE_TERTIARY_LITE}
        loading={loading}
      />
    </div>
  );
};

export default ReferralStats;
